import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { KingNewService } from '../../king-new.service';

import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';
import { SkinsRowComponent } from '@old-app/components/skins-row/skins-row.component';
import { ModalService } from '@features/modals/services/modal.service';
import { CostComponent } from '@core/components/cost/cost.component';

@Component({
  selector: 'app-king-queue',
  templateUrl: './king-queue.component.html',
  styleUrls: ['./king-queue.component.scss'],
  standalone: true,
  imports: [SkinsRowComponent, NgpTooltip, NgpTooltipTrigger, CostComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingQueueComponent {
  public readonly kingService = inject(KingNewService);
  private readonly modalService = inject(ModalService);

  openDepositModal() {
    this.modalService.openModal('DepositKingModal');
  }
}
